<template>
  <div class="container-fluid">
    <h2 class="page-heading">Магнитные карты</h2>
    <transition name="fade">
    <div v-if="options">
      <div class="form-group" style="max-width: 20em;">
        <select id="select-cards" class="form-control custom-select" v-model="selected">
          <option value="">Нет</option>
          <option v-for="option in options" :value="option">{{ option }}</option>
        </select></div>
      <div class="card mb-4" v-if="selected">
        <h3 class="card-header"><span class="text-caps">Расписание отправки</span></h3>
        <div class="card-body">
          <schedule-editor v-model="schedule" withMinutes="true"></schedule-editor>
        </div>
      </div>
      <btn-action
        v-if="$root.checkPermission('web_ta_magnet_edit')"
        class="btn"
        :disabled="!isDirty"
        :class="{'btn-primary': isDirty}"
        @click="save"
        v-text="'Сохранить'"
      />
    </div></transition>
  </div>
</template>

<script>
  import moment from 'moment'
  import isEqual from 'lodash/isEqual'
  import api from '@/api'
  import ScheduleEditor from '../../../components/schedule/editor'
  import BtnAction from '../../../components/btn-action'

  export default {
    components: {BtnAction, ScheduleEditor},
    props: {
      id: {
        required: true,
      },
      machine: {
        type: Object,
      },
    },
    data () {
      return {
        selected: this.machine.cards || '',
        schedule: this.machine.cards_schedule,
      }
    },
    asyncComputed: {
      options () {
        return api.get('cards')
          .then(({data}) => data)
      },
    },
    computed: {
      formattedSelected () {
        return this.selected || null // convert empty string to null
      },
      isDirty () {
        return (
          this.formattedSelected !== this.machine.cards ||
          (this.selected && !isEqual(this.schedule, this.machine.cards_schedule))
        )
      },
    },
    methods: {
      save () {
        const data = {cards: this.formattedSelected}
        if (data.cards) data.cards_schedule = this.schedule

        return api.put(`machines/${this.id}`, data).then(() => {
          this.machine.cards = this.formattedSelected
          this.machine.cards_schedule = this.schedule
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/cards.vue